module.exports = __webpack_public_path__ + "assets/c8c1e710c9a6f3cff97f1068e6929075.mp3";